"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('startup-layout', {
    ref: "layout",
    staticClass: "kiwi-welcome-simple kiwi-welcome-simple--brite kiwi-welcome-simple--floating",
    scopedSlots: _vm._u([_vm.startupOptions.altComponent ? {
      key: "connection",
      fn: function () {
        return [_c(_vm.startupOptions.altComponent, {
          tag: "component",
          on: {
            "close": _vm.onAltClose
          }
        }), _vm._v(" 🤳🏽 ")];
      },
      proxy: true
    } : {
      key: "connection",
      fn: function () {
        return [_c('form', {
          staticClass: "u-form u-form--big kiwi-welcome-simple-form card shadow-lg border-0",
          on: {
            "submit": function ($event) {
              $event.preventDefault();
              return _vm.formSubmit.apply(null, arguments);
            }
          }
        }, [_c('div', {
          staticClass: "card-body p-3 p-sm-4"
        }, [_c('h2', {
          staticClass: "card-title text-center mb-3 kiwi-welcome-simple-greeting",
          domProps: {
            "innerHTML": _vm._s(_vm.greetingText)
          }
        }), _vm.network && (_vm.connectErrors.length > 0 || _vm.network.state_error) ? _c('div', {
          staticClass: "kiwi-welcome-simple-error alert alert-danger",
          attrs: {
            "role": "alert"
          }
        }, [_vm.connectErrors.length > 0 ? _vm._l(_vm.connectErrors, function (err) {
          return _c('span', {
            key: err
          }, [_vm._v(_vm._s(err))]);
        }) : [_c('span', [_vm._v(_vm._s(_vm.$t('network_noconnect')))]), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]], 2) : _vm._e(), !_vm.showSocialOptions ? [_c('input-text', {
          directives: [{
            name: "focus",
            rawName: "v-focus",
            value: !_vm.isIframe && (!_vm.nick || !_vm.show_password_box),
            expression: "!isIframe && (!nick || !show_password_box)"
          }],
          class: {
            'kiwi-welcome-invalid-nick': !_vm.isNickValid
          },
          attrs: {
            "label": _vm.$t('nick'),
            "type": "text"
          },
          model: {
            value: _vm.nick,
            callback: function ($$v) {
              _vm.nick = $$v;
            },
            expression: "nick"
          }
        }), _vm.showPass && _vm.toggablePass ? _c('div', {
          staticClass: "kiwi-welcome-simple-input-container form-check mb-3"
        }, [_c('label', {
          staticClass: "kiwi-welcome-simple-have-password form-check-label"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.show_password_box,
            expression: "show_password_box"
          }],
          staticClass: "form-check-input",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : _vm.show_password_box
          },
          on: {
            "change": function ($event) {
              var $$a = _vm.show_password_box,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.show_password_box = $$c;
              }
            }
          }
        }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('password_have')) + " ")])])]) : _vm._e(), _vm.showPass && (_vm.show_password_box || !_vm.toggablePass) ? _c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_c('input-text', {
          directives: [{
            name: "focus",
            rawName: "v-focus",
            value: !_vm.isIframe && _vm.nick || _vm.show_password_box,
            expression: "(!isIframe && nick) || show_password_box"
          }],
          attrs: {
            "show-plain-text": true,
            "label": _vm.$t('password'),
            "type": "password"
          },
          model: {
            value: _vm.password,
            callback: function ($$v) {
              _vm.password = $$v;
            },
            expression: "password"
          }
        })], 1) : _vm._e(), _vm.termsContent ? _c('div', {
          staticClass: "kiwi-welcome-simple-terms mb-3"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.termsAccepted,
            expression: "termsAccepted"
          }],
          staticClass: "form-check-input flex-shrink-0",
          attrs: {
            "id": "kiwi-welcome-terms",
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.termsAccepted) ? _vm._i(_vm.termsAccepted, null) > -1 : _vm.termsAccepted
          },
          on: {
            "change": function ($event) {
              var $$a = _vm.termsAccepted,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.termsAccepted = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.termsAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.termsAccepted = $$c;
              }
            }
          }
        }), _c('div', {
          staticClass: "kiwi-welcome-simple-terms-content",
          domProps: {
            "innerHTML": _vm._s(_vm.termsContent)
          }
        })]) : _vm._e(), _c('captcha', {
          attrs: {
            "network": _vm.network
          }
        })] : _vm._e(), !_vm.showSocialOptions && (!_vm.network || _vm.network.state === 'disconnected') ? _c('button', {
          staticClass: "btn btn-primary w-100 py-2 kiwi-welcome-simple-start",
          attrs: {
            "disabled": !_vm.readyToStart,
            "type": "submit"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.buttonText)
          }
        }) : !_vm.showSocialOptions ? _c('button', {
          staticClass: "btn btn-primary w-100 py-2 kiwi-welcome-simple-start",
          attrs: {
            "type": "button",
            "disabled": ""
          }
        }, [_c('i', {
          staticClass: "fa fa-spin fa-spinner",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _c('div', {
          staticClass: "kiwi-welcome-social-container"
        }, [!_vm.network || _vm.network.state === 'disconnected' ? _c('button', {
          staticClass: "btn btn-outline-primary w-100 py-2 mt-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.toggleSocialOptions
          }
        }, [_c('i', {
          staticClass: "fa fa-plug",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Conectar con redes ")]) : _vm._e(), _c('transition', {
          attrs: {
            "name": "social-expand"
          }
        }, [_vm.showSocialOptions ? _c('div', {
          staticClass: "kiwi-social-buttons-grid mt-2"
        }, [_c('button', {
          staticClass: "btn btn-social btn-gmail",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.loginWithAuth0
          }
        }, [_c('i', {
          staticClass: "fa fa-google"
        }), _vm._v(" Gmail ")]), _c('button', {
          staticClass: "btn btn-social btn-discord",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.loginWithDiscord
          }
        }, [_c('i', {
          staticClass: "fa fa-comments"
        }), _vm._v(" Discord ")]), _c('button', {
          staticClass: "btn btn-social btn-x",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.loginWithX
          }
        }, [_c('i', {
          staticClass: "fa fa-twitter"
        }), _vm._v(" Twitter (X) ")]), _c('button', {
          staticClass: "btn btn-social btn-telegram",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.loginWithTelegram
          }
        }, [_c('i', {
          staticClass: "fa fa-paper-plane"
        }), _vm._v(" Telegram ")])]) : _vm._e()])], 1), _c('div', {
          staticClass: "mt-3 small text-body-secondary",
          domProps: {
            "innerHTML": _vm._s(_vm.footerText)
          }
        }), _c('social-links', {
          attrs: {
            "links": _vm.socialLinks,
            "variant": "welcome"
          }
        })], 2)])];
      },
      proxy: true
    }], null, true)
  });
};
var staticRenderFns = exports.staticRenderFns = [];